import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { goFunc, handlePostMessage } from '../js/postMessage';
import { getParsedLocalStorageItem } from '../js/script';

export default function CloseTest() {
  const location = useLocation();

  useEffect(() => {
    const app = getParsedLocalStorageItem('app');
    const currentUrl = window.location.href;
    if (app) {
      goFunc({ url: currentUrl, payType: 'MY_PAY' });
      // handlePostMessage({ actionType: 'goFunc', params: { url: currentUrl, payType: 'MY_PAY' } });
      // goBack();
      // onClose();
      handlePostMessage({ actionType: 'onClose' });
    }
    const sendMessage = () => {
      if (window.opener) {
        const message = {
          type: 'URL_UPDATE',
          url: currentUrl,
          payType: 'MY_PAY',
        };
        window.opener.postMessage(message);
      }
    };

    // 페이지 로드 시 현재 URL 전송
    sendMessage();

    window.close();
  }, [location]);
  return <p>팝업테스트</p>;
}
